/** Mock – יוחלף ב-GET /reports/documents/email-recipients */
export const MOCK_REPORT_EMAIL_RECIPIENTS = [
  { key: 'store_sales', label: 'מוכר/ת חנות – טרבלסי', email: 'store@trblsi.example.com' },
  { key: 'office', label: 'משרד', email: 'office@example.com' },
  { key: 'project_manager', label: 'מנהל פרויקט', email: 'pm@example.com' },
];

export const MOCK_REPORT_REQUEST_TYPES = [
  { key: 'document_update', label: 'עדכון מסמכים' },
  { key: 'shipment_prep', label: 'הכנת שורות למשלוח' },
  { key: 'general', label: 'בקשה כללית' },
];

export const DOCUMENTS_SEND_UPDATE_API = 'POST /reports/documents/send-update';

export const getReportRequestTypeLabel = (key) =>
  MOCK_REPORT_REQUEST_TYPES.find((t) => t.key === key)?.label || key;

export const getReportRecipientLabel = (key) =>
  MOCK_REPORT_EMAIL_RECIPIENTS.find((r) => r.key === key)?.label || key;

export const getReportRecipientEmail = (key) =>
  MOCK_REPORT_EMAIL_RECIPIENTS.find((r) => r.key === key)?.email || '';

/** Mock – סימולציית שליחה */
export function mockSendReportUpdateEmail(payload) {
  return new Promise((resolve) => {
    window.setTimeout(() => {
      resolve({
        success: true,
        messageId: `mock-${Date.now()}`,
        sentAt: new Date().toISOString(),
        itemCount: payload.items.length,
        recipientEmail: payload.recipientEmail,
      });
    }, 900);
  });
}
